/* ═══════════════════════════════════════════════
   Dark Bundles by Bunny — Theme JavaScript
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  // ─── Starfield ───────────────────────────────
  const canvas = document.getElementById('stars-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    const STAR_COUNT = 180;
    const stars = Array.from({ length: STAR_COUNT }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 1.2 + 0.2,
      alpha: Math.random(),
      speed: Math.random() * 0.003 + 0.001,
      phase: Math.random() * Math.PI * 2,
    }));

    function drawStars(t) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(function (s) {
        const a = (Math.sin(t * s.speed + s.phase) + 1) / 2;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(192, 132, 252, ' + (a * 0.8) + ')';
        ctx.fill();
      });
      requestAnimationFrame(drawStars);
    }
    requestAnimationFrame(drawStars);
  }

  // ─── Logo sparkles ────────────────────────────
  const sparkleContainer = document.getElementById('logo-sparkles');
  if (sparkleContainer) {
    const positions = [
      { top: '5%',  left:  '20%' },
      { top: '15%', right: '10%' },
      { top: '50%', left:  '0%'  },
      { top: '80%', left:  '15%' },
      { top: '90%', right: '20%' },
      { top: '40%', right: '0%'  },
      { top: '70%', left:  '50%' },
      { top: '10%', left:  '55%' },
    ];
    positions.forEach(function (pos, i) {
      const el = document.createElement('div');
      el.className = 'sparkle';
      Object.assign(el.style, pos, { animationDelay: (i * 0.3) + 's' });
      sparkleContainer.appendChild(el);
    });
  }

  // ─── Scroll reveal ────────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          setTimeout(function () {
            e.target.classList.add('visible');
          }, i * 80);
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    // Fallback for browsers without IntersectionObserver
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // ─── Mobile burger menu ───────────────────────
  const burger = document.getElementById('nav-burger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      burger.classList.toggle('is-open', isOpen);
      burger.setAttribute('aria-expanded', String(isOpen));
      mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    });
    // Close menu when any link inside it is clicked
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // ─── Nav scroll effect ───────────────────────
  const nav = document.getElementById('site-nav') || document.querySelector('nav');
  if (nav) {
    function updateNav() {
      if (window.scrollY > 80) {
        nav.style.background = 'rgba(6,3,15,0.92)';
        nav.style.backdropFilter = 'blur(12px)';
        nav.style.borderBottom = '1px solid rgba(168,85,247,0.1)';
      } else {
        nav.style.background = 'linear-gradient(to bottom, rgba(6,3,15,0.95), rgba(6,3,15,0))';
        nav.style.backdropFilter = 'blur(2px)';
        nav.style.borderBottom = 'none';
      }
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

})();
